'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RNG = exports.CHARSET = exports.HASH_LENGTH = exports.CharsetLengthError = exports.RandomHash = exports.generateHash = undefined;

var _crypto = require('crypto');

var _baseN = require('./baseN');

const HASH_LENGTH = 6;
const CHARSET = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789-_';
const RNG = _crypto.randomBytes;

function generateHash(options = {}) {
    const {
        length: hashLength = HASH_LENGTH,
        charset = CHARSET,
        rng = RNG
    } = options;

    const numBytes = Math.ceil(hashLength * (0, _baseN.charLength)(charset) / 8);
    const bytes = rng(numBytes);

    const encode = (0, _baseN.createEncoding)(charset);
    let hash = encode(bytes);
    hash = hash.slice(0, hashLength);

    return hash.join('');
}

class RandomHash {
    constructor(options = {}) {
        const {
            length,
            charset,
            rng
        } = options;

        this.hashLength = length || HASH_LENGTH;
        this.charset = charset || CHARSET;
        this.rng = rng || RNG;

        (0, _baseN.charLength)(this.charset);

        this.generateHash = this.generateHash.bind(this);

        const instance = this;

        Object.defineProperty(this.generateHash, 'length', {
            get() {
                return instance.hashLength;
            },
            set(newHashLength) {
                instance.hashLength = newHashLength;
            }
        });

        Object.defineProperty(this.generateHash, 'charset', {
            get() {
                return instance.charset;
            },
            set(newCharset) {
                (0, _baseN.charLength)(newCharset);

                instance.charset = newCharset;
            }
        });

        Object.defineProperty(this.generateHash, 'rng', {
            get() {
                return instance.rng;
            },
            set(newRng) {
                instance.rng = newRng;
            }
        });

        Object.setPrototypeOf(this.generateHash, this.constructor.prototype);

        return this.generateHash;
    }

    generateHash(options = {}) {
        const {
            length = this.hashLength,
            charset = this.charset,
            rng = this.rng
        } = options;

        return generateHash({
            length,
            charset,
            rng
        });
    }
}

exports.default = generateHash;
exports.generateHash = generateHash;
exports.RandomHash = RandomHash;
exports.CharsetLengthError = _baseN.CharsetLengthError;
exports.HASH_LENGTH = HASH_LENGTH;
exports.CHARSET = CHARSET;
exports.RNG = RNG;


//////////////////
// WEBPACK FOOTER
// ./node_modules/random-hash/dist/index.js
// module id = ./node_modules/random-hash/dist/index.js
// module chunks = 5 6